import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../KeyComponents/Icon';

function Badge({
  children,
  className,
  variant,
  size,
  iconBefore,
  iconAfter,
  iconType,
  disabled,
  withDot,
  uppercase,
  onClick
}) {
  // check children string is a number
  let isNumber = false;
  if ((typeof children === 'number') || (typeof children === 'string' && !Number.isNaN(Number(children)))) {
    isNumber = true;
  }

  return (
    <div
      className={classNames(
        'badge',
        className,
        variant && `badge-${variant}`,
        size && `badge-${size}`,
        isNumber && 'badge-number',
        disabled && 'badge-disabled',
        uppercase && 'badge-uppercase'
      )}
      onClick={onClick}
    >
      {withDot && <div className="badge-dot" />}
      {iconBefore && <Icon icon={iconBefore} type={iconType} size="xxs" className="badge-icon badge-icon-before" />}
      {children}
      {iconAfter && <Icon icon={iconAfter} type={iconType} size="xxs" className="badge-icon badge-icon-after" />}
    </div>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'error',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  iconBefore: PropTypes.string,
  iconAfter: PropTypes.string,
  disabled: PropTypes.bool,
  withDot: PropTypes.bool,
  iconType: PropTypes.string,
  uppercase: PropTypes.bool,
  onClick: PropTypes.func,
};

Badge.defaultProps = {
  className: '',
  variant: 'primary',
  size: null,
  iconBefore: null,
  iconAfter: null,
  disabled: false,
  withDot: false,
  iconType: 'line',
  uppercase: false,
  onClick: null,
};

export default Badge;
